import { getCurrentInstance } from "vue"
import { Store } from "vuex"
import { RootState } from "@/store"

export const useStore = (): Store<RootState> => {
    const instance = getCurrentInstance()

    if (!instance || !instance.proxy.$store) {
        throw new Error("Store is not available in this instance.")
    }

    return instance.proxy.$store as Store<RootState>
}
